// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__Xinm9","Icon":"Button_Icon__3WlHM","Inverted":"Button_Inverted__2QF29","Empty":"Button_Empty__30Dwi"};